export default "__VITE_ASSET__D7xZ9w3l__"